import loadable from "@loadable/component"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"

import { retry } from "helpers/application"

import fetchCollection from "./hoc/fetch-collection"
import useCollection from "./hoc/use-collection"
import FullLoading from "./loaders"

const GenericNotFound = loadable(() =>
  retry(() => import("app/generic-not-found"))
)
const Collection = loadable(() => retry(() => import("./index")), {
  fallback: <FullLoading />,
})
const Homepage = loadable(() => retry(() => import("areas/homepage/jewlr")), {
  fallback: <FullLoading />,
})
const Landing = loadable(() => retry(() => import("areas/landing")), {
  fallback: <FullLoading />,
})

const LoadCollection = ({ staticContext }) => {
  const { data, disabled, error } = useCollection()
  const { model } = data || {}
  const loading = useSelector((state) => state.collection.loading)

  if (error || disabled) {
    return <GenericNotFound staticContext={staticContext} />
  } else if (!data || loading === "full") {
    return <FullLoading />
  } else if (model === "landing") {
    return "homepage" === data.url_path ? <Homepage /> : <Landing />
  }

  return <Collection />
}

LoadCollection.propTypes = {
  staticContext: PropTypes.object,
}

export default fetchCollection(LoadCollection)
